import React, { FC, useState } from "react";
import { Button, Spin } from "antd";

interface Props {
  onSelect: (type: any) => void;
}

const AuthMainPanel: FC<Props> = ({ onSelect }) => {
  const [loading, setLoading] = useState(false);

  const signInUser = (pathName: string) => {
    const baseUrl = process.env.REACT_APP_BASE_URL as string;
    const isLocalhost = baseUrl.includes('localhost') || baseUrl.includes('127.0.0.1');
    const protocol = isLocalhost ? 'http://' : 'https://';
    const cleanBaseUrl = baseUrl.replace(/^https?:\/\//, '');
    const redirectTo = `${protocol}${cleanBaseUrl}/${pathName}?path=finishSignup`;
    window.location.href = redirectTo;
  };

  const handleGetStarted = () => {
    const path = process.env.REACT_APP_OFFICE_AUTH_ENDPOINT;
    setLoading(true);
    if (path) signInUser(path);
  };

  return (
    <div className="button-container">
      <Button
        type="primary"
        className="sign-up"
        onClick={handleGetStarted}
        disabled={loading}
      >
        Get Started
        {loading && <Spin style={{ marginLeft: 10 }} />}
      </Button>
    </div>
  );
};

export default AuthMainPanel;
